import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'primeng/dynamicdialog';
import { QrcodesDialogComponent } from 'src/app/components/qrcodes/qrcodes-dialog/qrcodes-dialog.component';
import { QrcodesPdfDialogComponent } from 'src/app/components/qrcodes/qrcodes-pdf-dialog/qrcodes-pdf-dialog.component';
import { BoatQRCodeDTO } from 'src/app/models/dtos/boatQRCodeDTO';
import { BoatTableDTO } from 'src/app/models/dtos/boatTableDTO';
import { BoatService } from 'src/app/services/boat.service';
import { FormatUtil } from 'src/app/utils/format.util';

@Component({
  selector: 'app-boats-qrcodes',
  templateUrl: './boats-qrcodes.component.html',
  styleUrls: ['./boats-qrcodes.component.scss']
})
export class BoatsQrcodesComponent implements OnInit {

  qrcodes: BoatQRCodeDTO[];
  path: any;
  boats: BoatTableDTO[];
  boatsList: BoatTableDTO[];
  selectedBoats: BoatTableDTO[];

  constructor(
    private boatService: BoatService,
    private sanitizer: DomSanitizer,
    private dialog: DialogService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    await this.getBoats();
    this.spinner.hide();
  }

  async getBoats(): Promise<void> {
    return new Promise<void>(async resolve => {
      this.boatService.getTable().subscribe(
        async (boats: BoatTableDTO[]) => {
          this.boatsList = boats;
          this.boats = boats;
          resolve();
        },
        async (error) => {
          console.log(error);
          resolve();
        });
    });
  }

  getQrCode(boatId): void {
    this.spinner.show();
    this.boatService.getQRCode(boatId).subscribe(
      (blob: any) => {
        this.spinner.hide();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const path = reader.result;
          this.dialog.open(QrcodesDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: { path },
            dismissableMask: true,
            showHeader: false
          });
        };
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  openQrCode(boat: BoatTableDTO): void {
    this.getQrCode(boat.id);
  }

  generatePDF(): void {
    this.spinner.show();
    const ids = this.selectedBoats.map((x) => x.id);
    this.boatService.getQRCodes(ids).subscribe(
      (pdf) => {
        this.spinner.hide();
        const file = new Blob([pdf], { type: 'application/pdf' });
        const path = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
        this.dialog.open(QrcodesPdfDialogComponent, {
          width: '95%',
          height: 'auto',
          data: { path },
          dismissableMask: true,
        });
      },
      (error) => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }

  filterGlobal(event): void {
    const value = event.target.value;
    this.boats = this.boatsList.filter(
      (b) =>
        (FormatUtil.getNotAccents(b.name).toUpperCase().includes(FormatUtil.getNotAccents(value).toUpperCase()) ||
          b.name.toUpperCase().includes(value.toUpperCase())
        ) ||
        (FormatUtil.getNotAccents(b.shipyardName).toUpperCase().includes(FormatUtil.getNotAccents(value).toUpperCase()) ||
          b.shipyardName.toUpperCase().includes(value.toUpperCase())
        ) ||
        (FormatUtil.getNotAccents(b.shipyardModelName).toUpperCase().includes(FormatUtil.getNotAccents(value).toUpperCase()) ||
          b.shipyardModelName.toUpperCase().includes(value.toUpperCase())
        ) ||
        (b.tieRegister && b.tieRegister.includes(value.toUpperCase()))
    );
  }
}
